import Vue from 'vue';
import Router from 'vue-router';
import { weChatShare } from '$wechat';
import { useInVueRouter } from '$use-in-vue-router';
import RouterID from '$use-in-vue-router/router-id';
import { routerBeforeEach } from "$use-in-vue-router/router-before";
import { routerAfterEach } from "$use-in-vue-router/router-after";
import RouterMeta from '$use-in-vue-router/router-meta';
import { useInVueRouterProgram } from '../use-in-vue-router-program';

//路由地址
import routes from './routes';

Vue.use(Router);

//router相关的插件
useInVueRouter(Router);


//路由标记
//export const routerID = new RouterID();
export const routerMeta = new RouterMeta();

const router = new Router({
  namespace: true,
//  routes: routerID.addID(routes)
  routes: routerMeta.setMeta(routes),
});


//项目扩展router
useInVueRouterProgram({
  Router,
//  routerID
});

//router before each
routerBeforeEach({
  router,
  beforeEach(to, from) {
    //四种情况，path，false，Error参照官方文档中的next处理
    // true 或者 undefined 走默认的next()处理
    //处理多层级的的next状态查看一下RouterNext的处理
    return true;
  }
});

//router after each
routerAfterEach({
  router,
  //根据项目需要的after each（可选）
  afterEach(to, from) {
    //console.log(to, from);
  },
  unAfterHook() {
    weChatShare();
  }
});

//test router in ssr
export function createRouter() {
  const router = new Router({
    namespace: true,
    routes: [home, bindPhone, components]
  });
  return router;
}

export default router;
